import { types } from "../types/types";

export const startLoadingUIPago = () => ({
    type: types.startloadingUIPago
});

export const finishLoadingUIPago = () => ({
    type: types.finishloadingUIPago
});

export const setCompletado = (indicador) => ({
    type: types.setCompletado,
    payload: indicador

})